import { lazy, Suspense } from 'react';

/**
 * Dev-build gate for the experiments devtool (see
 * `ExperimentsDevtoolsPanel.tsx` for the panel itself).
 *
 * `import.meta.env.DEV` is a compile-time constant: in production builds the
 * ternary's dev branch is dead code, so the dynamic import — and with it the
 * entire panel chunk — is dropped from the bundle graph. Dev builds lazy-load
 * the panel on first render. Same pattern as TanStack Query Devtools.
 */
const DevtoolsPanel = import.meta.env.DEV ? lazy(() => import('./ExperimentsDevtoolsPanel')) : null;

export function ExperimentsDevtools() {
  if (!DevtoolsPanel) return null;
  return (
    <Suspense fallback={null}>
      <DevtoolsPanel />
    </Suspense>
  );
}
